import React, { Component } from 'react';
import { Container, Row, Col, Input, Button, Alert, NavLink } from 'reactstrap';
import { Link } from 'react-router-dom';
import { default as ReactSelect } from "react-select";
import moment from "moment";
import AuthFunctions from '../services/AuthService';
import AdminFunctions from '../admin/AdminFunctions';
import Session from '../auth/Session';

export class LeaseDetailsSummary extends Component {
    static displayName = LeaseDetailsSummary.name;

    constructor(props) {
        super(props);
        const search = this.props.location.search;
        const params = new URLSearchParams(search);
        const id = params.get('id');

        this.state = {
            sregionOptions: [{ label: "Branch", value: "Branch" }, { label: "Headquarters", value: "Headquarters" }, { label: "Independent", value: "Independent" }, { label: "Sublessor", value: "Sublessor" }],
            sstateOptions: [{ label: "AL", value: "AL" }, { label: "AK", value: "AK" }, { label: "AZ", value: "AZ" }, { label: "AR", value: "AR" }, { label: "CA", value: "CA" }, { label: "CO", value: "CO" }, { label: "CT", value: "CT" }, { label: "DE", value: "DE" }, { label: "DC", value: "DC" }, { label: "FL", value: "FL" }, { label: "GA", value: "GA" }, { label: "HI", value: "HI" }, { label: "ID", value: "ID" }, { label: "IL", value: "IL" }, { label: "IN", value: "IN" }, { label: "IA", value: "IA" }, { label: "KS", value: "KS" }, { label: "KY", value: "KY" }, { label: "LA", value: "LA" }, { label: "ME", value: "ME" }, { label: "MD", value: "MD" }, { label: "MA", value: "MA" }, { label: "MI", value: "MI" }, { label: "MN", value: "MN" }, { label: "MS", value: "MS" }, { label: "MO", value: "MO" }, { label: "MT", value: "MT" }, { label: "NE", value: "NE" }, { label: "NV", value: "NV" }, { label: "NH", value: "NH" }, { label: "NJ", value: "NJ" }, { label: "NM", value: "NM" }, { label: "NY", value: "NY" }, { label: "NC", value: "NC" }, { label: "ND", value: "ND" }, { label: "OH", value: "OH" }, { label: "OK", value: "OK" }, { label: "OR", value: "OR" }, { label: "PA", value: "PA" }, { label: "RI", value: "RI" }, { label: "SC", value: "SC" }, { label: "SD", value: "SD" }, { label: "TN", value: "TN" }, { label: "TX", value: "TX" }, { label: "UT", value: "UT" }, { label: "VT", value: "VT" }, { label: "VA", value: "VA" }, { label: "WA", value: "WA" }, { label: "WV", value: "WV" }, { label: "WI", value: "WI" }, { label: "WY", value: "WY" }],
            sleaseOptions: [{ label: "Full Service", value: "Full Service" }, { label: "Modified Gross", value: "Modified Gross" }, { label: "NNN", value: "NNN" }],
            sstatusOptions: [{ label: "Open", value: "1" }, { label: "Closed", value: "2" }],
            lease: {},
            leaseId: id,
            editMode: false,
            isAdmin: false
        }

        this.checkAuthenticated();
    }

    async checkAuthenticated() {
        var isAuthenticated = await AuthFunctions.getAuthenticatedAsync();
        var isAdmin = false;
        var isWrite = false;
        if (!isAuthenticated) {
            this.props.history.push('/login');
        }
        if (isAuthenticated) {
            isAdmin = await AdminFunctions.isAdminAsync();
            isWrite = await AdminFunctions.isRole("Write");
        }
        this.setState({ isAdmin: isAdmin || isWrite });
    }

    async componentDidMount() {
        var _token = Session.getToken();
        this.GetLease();
    }

    handleSregionChange = (selected) => {
        console.log("Selected:");
        console.log(selected);
        //this.setState({
        //    sregion: [selected]
        //});
    };
    render() {
        return (
            <div className="pageDiv">
                <div id="head">
                    <h3 style={{ textAlign: 'center' }}>Lease Details</h3>
                </div>
                <div id="body" className="g-warm-gray-c">
                    <Row>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>

                        </Col>
                        <Col>
                            <label className="g-almost-black-c addressTitle">
                                {this.state.lease.sd_address}<br />
                                {this.state.lease.sd_city}, {this.state.lease.sd_state} {this.state.lease.sd_zip}
                            </label> {/*//For header*/}
                        </Col>
                    </Row>
                    <Row className="g-warm-gray-bg g-warm-gray-c" style={{ 'textAlign': 'center' }}>
                        <Col className="g-orange-bg g-orange-c">
                                Summary
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-RentTerms?id=' + this.state.leaseId}
                            >
                                Rent Terms
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-CriticalDates?id=' + this.state.leaseId}
                            >
                                Critical Dates
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Notes?id=' + this.state.leaseId}
                            >
                                Notes
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Documents?id=' + this.state.leaseId}
                            >
                                Documents
                            </NavLink>
                        </Col>
                        <Col>
                            <NavLink className="noStyleLink noNavLink"
                                tag={Link}
                                to={'/Lease/LeaseDetails-Contacts?id=' + this.state.leaseId}
                            >
                                Contacts
                            </NavLink>
                        </Col>
                    </Row>
                </div>
                <div id="body" className="g-light-gray-c">
                    <Row className="rowSpacing">
                        <Col className="colLeft">
                            <label>Office/Store #</label>
                        </Col>
                        <Col className="colRight">
                            {this.state.editMode === false && (
                                <div id="plain">&nbsp;
                                    <label>{this.state.lease.sd_num}</label>
                                </div>
                            )}
                            {this.state.editMode === true && (
                                <div id="plain">&nbsp;
                                    <input
                                        type="text"
                                        value={this.state.lease.sd_num}
                                        onChange={(e) => { var tempLease = this.state.lease; tempLease.sd_num = e.target.value; this.setState({ lease: tempLease }) }}
                                        name="sd_num"
                                        id='sd_num'
                                        valid={this.state.sd_num ? true : false}
                                        invalid={!this.state.sd_num ? true : false}
                                        className="inputSpacing"
                                    />
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col className="colLeft">
                            <label>Type</label>
                        </Col>
                        <Col className="colRight">
                            {this.state.editMode === false && (
                                <div id="plain">&nbsp;
                                    <label>{this.state.lease.sd_region}</label>
                                </div>
                            )}
                            {this.state.editMode === true && (
                                <div id="plain">&nbsp;
                                    <select
                                        options={this.state.lease.sregionOptions}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        components={{
                                            Option
                                        }}
                                        onChange={(e) => { var tempLease = this.state.lease; tempLease.sd_region = e.target.value; this.setState({ lease: tempLease }) }}
                                        value={this.state.lease.sd_region}
                                        valid={this.state.lease.sd_region}
                                        invalid={!this.state.lease.sd_region}
                                    >
                                        <option key=''></option>
                                        {this.state.sregionOptions.map(option => {
                                            return (
                                                <option key={option.value}>
                                                    {option.label}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            )}

                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col className="colLeft">
                            <label>Building Name</label>
                        </Col>
                        <Col className="colRight">
                            {this.state.editMode === false && (
                                <div id="plain">&nbsp;
                                    <label>{this.state.lease.sd_building}</label>
                                </div>
                            )}
                            {this.state.editMode === true && (
                                <div id="plain">&nbsp;
                                    <input
                                        type="text"
                                        value={this.state.lease.sd_building}
                                        onChange={(e) => { var tempLease = this.state.lease; tempLease.sd_building = e.target.value; this.setState({ lease: tempLease }) }}
                                        name="sd_building"
                                        id='sd_building'
                                        valid={this.state.sd_building ? true : false}
                                        invalid={!this.state.sd_building ? true : false}
                                        className="inputSpacing"
                                    />
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col className="colLeft">
                            <label>Street Address</label>
                        </Col>
                        <Col className="colRight">
                            {this.state.editMode === false && (
                                <div id="plain">&nbsp;
                                    <label>{this.state.lease.sd_address}</label>
                                </div>
                            )}
                            {this.state.editMode === true && (
                                <div id="plain">&nbsp;
                                    <input
                                        type="text"
                                        value={this.state.lease.sd_address}
                                        onChange={(e) => { var tempLease = this.state.lease; tempLease.sd_address = e.target.value; this.setState({ lease: tempLease }) }}
                                        name="sd_address"
                                        id='sd_address'
                                        valid={this.state.sd_address ? true : false}
                                        invalid={!this.state.sd_address ? true : false}
                                        className="inputSpacing"
                                    />
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col className="colLeft">
                            <label>Address 2</label>
                        </Col>
                        <Col className="colRight">
                            {this.state.editMode === false && (
                                <div id="plain">&nbsp;
                                    <label>{this.state.lease.sd_address2}</label>
                                </div>
                            )}
                            {this.state.editMode === true && (
                                <div id="plain">&nbsp;
                                    <input
                                        type="text"
                                        value={this.state.lease.sd_address2}
                                        onChange={(e) => { var tempLease = this.state.lease; tempLease.sd_address2 = e.target.value; this.setState({ lease: tempLease }) }}
                                        name="sd_address2"
                                        id='sd_address2'
                                        valid={this.state.sd_address2 ? true : false}
                                        invalid={!this.state.sd_address2 ? true : false}
                                        className="inputSpacing"
                                    />
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col className="colLeft">
                            <label>City</label>
                        </Col>
                        <Col className="colRight">
                            {this.state.editMode === false && (
                                <div id="plain">&nbsp;
                                    <label>{this.state.lease.sd_city}</label>
                                </div>
                            )}
                            {this.state.editMode === true && (
                                <div id="plain">&nbsp;
                                    <input
                                        type="text"
                                        value={this.state.lease.sd_city}
                                        onChange={(e) => { var tempLease = this.state.lease; tempLease.sd_city = e.target.value; this.setState({ lease: tempLease }) }}
                                        name="sd_city"
                                        id='sd_city'
                                        valid={this.state.sd_city ? true : false}
                                        invalid={!this.state.sd_city ? true : false}
                                        className="inputSpacing"
                                    />
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col className="colLeft">
                            <label>State</label>
                        </Col>
                        <Col className="colRight">
                            {this.state.editMode === false && (
                                <div id="plain">&nbsp;
                                    <label>{this.state.lease.sd_state}</label>
                                </div>
                            )}
                            {this.state.editMode === true && (
                                <div id="plain">&nbsp;
                                    <select
                                        options={this.state.lease.sstateOptions}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        components={{
                                            Option
                                        }}
                                        onChange={(e) => { var tempLease = this.state.lease; tempLease.sd_state = e.target.value; this.setState({ lease: tempLease }) }}
                                        value={this.state.lease.sd_state}
                                        valid={this.state.lease.sd_state}
                                        invalid={!this.state.lease.sd_state}
                                    >
                                        <option key=''></option>
                                        {this.state.sstateOptions.map(option => {
                                            return (
                                                <option key={option.value}>
                                                    {option.label}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col className="colLeft">
                            <label>Zip</label>
                        </Col>
                        <Col className="colRight">
                            {this.state.editMode === false && (
                                <div id="plain">&nbsp;
                                    <label>{this.state.lease.sd_zip}</label>
                                </div>
                            )}
                            {this.state.editMode === true && (
                                <div id="plain">&nbsp;
                                    <input
                                        type="text"
                                        value={this.state.lease.sd_zip}
                                        onChange={(e) => { var tempLease = this.state.lease; tempLease.sd_zip = e.target.value; this.setState({ lease: tempLease }) }}
                                        name="sd_zip"
                                        id='sd_zip'
                                        valid={this.state.sd_zip ? true : false}
                                        invalid={!this.state.sd_zip ? true : false}
                                        className="inputSpacing"
                                    />
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col className="colLeft">
                            <label>Original Commencement Date</label>
                        </Col>
                        <Col className="colRight">
                            {(this.state.editMode === false && this.state.lease.sd_ocd) && (
                                <div id="plain">&nbsp;
                                    <label>{moment(this.state.lease.sd_ocd, "YYYY-MM-DDTHH:mm:ss").format("MM/DD/yyyy")}</label>
                                </div>
                            )}
                            {this.state.editMode === true && (
                                <div id="plain">&nbsp;
                                    <input
                                        type="date"
                                        value={moment(this.state.lease.sd_ocd, "YYYY-MM-DDTHH:mm:ss").format("yyyy-MM-DD")}
                                        onChange={(e) => { var tempLease = this.state.lease; tempLease.sd_ocd = e.target.value; this.setState({ lease: tempLease }) }}
                                        name="sd_ocd"
                                        id='sd_ocd'
                                        valid={this.state.sd_ocd ? true : false}
                                        invalid={!this.state.sd_ocd ? true : false}
                                        className="inputSpacing"
                                    />
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col className="colLeft">
                            <label>Current Commencement Date</label>
                        </Col>
                        <Col className="colRight">
                            {(this.state.editMode === false && this.state.lease.sd_ccd) && (
                                <div id="plain">&nbsp;
                                    <label>{moment(this.state.lease.sd_ccd, "YYYY-MM-DDTHH:mm:ss").format("MM/DD/yyyy")}</label>
                                </div>
                            )}
                            {this.state.editMode === true && (
                                <div id="plain">&nbsp;
                                    <input
                                        type="date"
                                        value={moment(this.state.lease.sd_ccd, "YYYY-MM-DDTHH:mm:ss").format("yyyy-MM-DD")}
                                        onChange={(e) => { var tempLease = this.state.lease; tempLease.sd_ccd = e.target.value; this.setState({ lease: tempLease }) }}
                                        name="sd_ccd"
                                        id='sd_ccd'
                                        valid={this.state.sd_ccd ? true : false}
                                        invalid={!this.state.sd_ccd ? true : false}
                                        className="inputSpacing"
                                    />
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col className="colLeft">
                            <label>Current Expiration Date</label>
                        </Col>
                        <Col className="colRight">
                            {(this.state.editMode === false && this.state.lease.sd_ced) && (
                                <div id="plain">&nbsp;
                                    <label>{moment(this.state.lease.sd_ced, "YYYY-MM-DDTHH:mm:ss").format("MM/DD/yyyy")}</label>
                                </div>
                            )}
                            {this.state.editMode === true && (
                                <div id="plain">&nbsp;
                                    <input
                                        type="date"
                                        value={moment(this.state.lease.sd_ced, "YYYY-MM-DDTHH:mm:ss").format("yyyy-MM-DD")}
                                        onChange={(e) => { var tempLease = this.state.lease; tempLease.sd_ced = e.target.value; this.setState({ lease: tempLease }) }}
                                        name="sd_ced"
                                        id='sd_ced'
                                        valid={this.state.sd_ced ? true : false}
                                        invalid={!this.state.sd_ced ? true : false}
                                        className="inputSpacing"
                                    />
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col className="colLeft">
                            <label>Square Feet</label>
                        </Col>
                        <Col className="colRight">
                            {this.state.editMode === false && (
                                <div id="plain">&nbsp;
                                    <label>{this.state.lease.sd_sqft}</label>
                                </div>
                            )}
                            {this.state.editMode === true && (
                                <div id="plain">&nbsp;
                                    <input
                                        type="text"
                                        value={this.state.lease.sd_sqft}
                                        onChange={(e) => { var tempLease = this.state.lease; tempLease.sd_sqft = e.target.value; this.setState({ lease: tempLease }) }}
                                        name="sd_sqft"
                                        id='sd_sqft'
                                        valid={this.state.sd_sqft ? true : false}
                                        invalid={!this.state.sd_sqft ? true : false}
                                        className="inputSpacing"
                                    />
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col className="colLeft">
                            <label>Lease</label>
                        </Col>
                        <Col className="colRight">
                            {this.state.editMode === false && (
                                <div id="plain">&nbsp;
                                    <label>{this.state.lease.sd_lease}</label>
                                </div>
                            )}
                            {this.state.editMode === true && (
                                <div id="plain">&nbsp;
                                    <select
                                        options={this.state.lease.sleaseOptions}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        components={{
                                            Option
                                        }}
                                        onChange={(e) => { var tempLease = this.state.lease; tempLease.sd_lease = e.target.value; this.setState({ lease: tempLease }) }}
                                        value={this.state.lease.sd_lease}
                                        valid={this.state.lease.sd_lease}
                                        invalid={!this.state.lease.sd_lease}
                                    >
                                        <option key=''></option>
                                        {this.state.sleaseOptions.map(option => {
                                            return (
                                                <option key={option.value}>
                                                    {option.label}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col className="colLeft">
                            <label>Security Deposit</label>
                        </Col>
                        <Col className="colRight">
                            {this.state.editMode === false && (
                                <div>
                                    {this.state.lease.sd_deposit != null ? '$' + this.state.lease.sd_deposit.toLocaleString("en-US", { minimumFractionDigits: 2, maximumFractionDigits: 2 }) : ''}
                                </div>
                            )}
                            {this.state.editMode === true && (
                                <div id="plain">&nbsp;
                                    <input
                                        type="text"
                                        value={this.state.lease.sd_deposit}
                                        onChange={(e) => { var tempLease = this.state.lease; tempLease.sd_deposit = e.target.value; this.setState({ lease: tempLease }) }}
                                        name="sd_deposit"
                                        id='sd_deposit'
                                        valid={this.state.sd_deposit ? true : false}
                                        invalid={!this.state.sd_deposit ? true : false}
                                        className="inputSpacing"
                                    />
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row className="rowSpacing">
                        <Col className="colLeft">
                            <label>Status</label>
                        </Col>
                        <Col className="colRight">
                            {this.state.editMode === false && (
                                <div id="plain">&nbsp;
                                    <label>{this.state.lease && this.state.lease.sd_status == 1 ? "Open" : (this.state.lease.sd_status == 2 ? "Closed" : "")}</label>
                                </div>
                            )}
                            {this.state.editMode === true && (
                                <div id="plain">&nbsp;
                                    <select
                                        options={this.state.lease.sstatusOptions}
                                        closeMenuOnSelect={true}
                                        hideSelectedOptions={false}
                                        components={{
                                            Option
                                        }}
                                        onChange={(e) => { var tempLease = this.state.lease; tempLease.sd_status = e.target.value; this.setState({ lease: tempLease }) }}
                                        value={this.state.lease.sd_status}
                                        valid={this.state.lease.sd_status}
                                        invalid={!this.state.lease.sd_status}
                                    >
                                        <option key=''></option>
                                        {this.state.sstatusOptions.map(option => {
                                            return (
                                                <option key={option.value} value={option.value}>
                                                    {option.label}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>
                            )}
                        </Col>
                    </Row>
                    <Row className="rowSpacing noBottomBorder" >
                        <Col className="colLeft">
                            &nbsp;
                        </Col>
                        <Col className="colRight" >
                            <div id="controls" style={{ textAlign: 'left' }}>
                                {this.state.editMode === false && (
                                    <>
                                        <Button
                                            color='primary'
                                            onClick={() => this.setState({ editMode: true })}
                                            className="g-orange-bg g-orange-c g-orange-button gButton"
                                            style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "100px" }}
                                            disabled={this.state.loading === true ? true : false}
                                            hidden={!this.state.isAdmin ? true : false}
                                        >
                                            Edit
                                        </Button>
                                        <Button
                                            color='primary'
                                            onClick={() => this.DeleteExisting()}
                                            className="g-orange-bg g-orange-c g-orange-button gButton"
                                            style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "100px", marginLeft: '10px' }}
                                            disabled={this.state.loading === true ? true : false}
                                            hidden={!this.state.isAdmin ? true : false}
                                        >
                                            Delete
                                        </Button>
                                    </>
                                )}
                                {this.state.editMode === true && (
                                    <>
                                        <Button
                                            color='primary'
                                            onClick={() => this.SaveLease()}
                                            className="g-orange-bg g-orange-c g-orange-button gButton"
                                            style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "100px", marginLeft: '10px' }}
                                            disabled={this.state.loading === true ? true : false}
                                            hidden={!this.state.isAdmin ? true : false}
                                        >
                                            Save
                                        </Button>
                                        <Button
                                            color='primary'
                                            onClick={() => this.setState({ editMode: false })}
                                            className="g-orange-bg g-orange-c g-orange-button gButton"
                                            style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "100px", marginLeft: '10px' }}
                                            disabled={this.state.loading === true ? true : false}
                                            hidden={!this.state.isAdmin ? true : false}
                                        >
                                            Cancel
                                        </Button>
                                    </>
                                )}
                                <Link 
                                    to="/Lease/ActiveLeases?search=1"
                                    color='primary'
                                    className="g-orange-bg g-orange-c g-orange-button gButton btn btn-primary"
                                    style={{ backgroundColor: '#F26230', color: "#FFFFFF", boxShadow: "0 2px 5px 0 rgba(0, 0, 0, .26)", minWidth: "50px", padding: '5px' }}
                                    disabled={this.state.loading === true ? true : false}
                                >
                                    Back To List
                                </Link>
                            </div>
                            

                        </Col>
                    </Row>
                </div>

            </div>
        );
    }
    async GetLease() {
        const token = Session.getToken();
        const response = await fetch('api/Leases/GetLease?id=' + this.state.leaseId, {
            headers: !token ? {} : { 'Authorization': `Bearer ${token}` },

        })
        const data = await response.json();
        if (data.sd_id === 0 || data.active === false) {
            alert("Lease does not exist.");
            window.location.href = '/home';
        }
        this.setState({ lease: data });
    }

    async SaveLease() {
        /*this.setState({ loading: true, loadingDocument: false });*/
        const token = Session.getToken();
        const response = await fetch('api/Leases/EditLease', {
            method: 'POST',
            headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
            body: JSON.stringify(this.state.lease)
        }).then(function (a) {

        });
        this.setState({ editMode: false });
        //const data = await response.json();
        //this.setState({ lease: data });
    }

    async DeleteExisting(candidate, index) {
        if (this.state.lease.sd_id) {
            if (window.confirm("Are you sure you want to delete this Lease?") === true) {
                const token = Session.getToken();
                const response = await fetch('api/Leases/DeleteLease', {
                    method: 'POST',
                    headers: !token ? {} : { 'Authorization': `Bearer ${token}`, 'Content-Type': 'application/json' },
                    body: JSON.stringify(this.state.lease)
                }).then(function (a) {
                    if (!a.active) {
                        window.location.href = '/home';
                    }
                });
            }
        }
        
    }
}

